module.exports = __webpack_public_path__ + "static/img/2.827389d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/2.png
// module id = 3isq
// module chunks = 0